import { gql } from '@apollo/client';

export default gql`
  query GetMediaItemStats(
    $courseId: String!
    $subjectId: String!
    $mediaId: String!
  ) {
    mediaStats(courseId: $courseId, subjectId: $subjectId, mediaId: $mediaId)
      @rest(
        type: "MediaItemStatsPayload"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/media/{args.mediaId}/stats"
      ) {
      media {
        name
      }
      totalViews
      avgProgressPercentage
      maxProgressPercentage
      students {
        _id
        name
        email
        group {
          name
        }
        totalViews
        avgProgressPercentage
        maxProgressPercentage
      }
    }
  }
`;
